module.exports = __webpack_public_path__ + "static/media/Nota La playa también sabea balance.7545af47.png";